import { FormField } from './FormField';
import { FormSection } from './FormSection';
import type { ProjectFormValues } from '../../schemas/project.schema';
import { Input } from '@/shared/components/ui/input';
import { Textarea } from '@/shared/components/ui/textarea';
import { messages } from '@/shared/constants/messages';
import { sizeForAudience } from '@/shared/constants/projectSizes';

interface SectionObjectiveProps {
  values: ProjectFormValues;
  errors: Partial<Record<keyof ProjectFormValues, string>>;
  onChangeText: (patch: Partial<ProjectFormValues>) => void;
}

export function SectionObjective({ values, errors, onChangeText }: SectionObjectiveProps) {
  const size = sizeForAudience(values.expected_audience);

  return (
    <FormSection
      id="objetivo"
      number={2}
      title={messages.projectSections.objective}
      description="É isto que quem analisa lê primeiro para entender o que o projeto é."
    >
      <FormField
        label="Objetivo do projeto"
        required
        error={errors.description}
        hint="O que vai acontecer, para quem, e por quê."
      >
        <Textarea
          value={values.description ?? ''}
          rows={5}
          maxLength={4000}
          placeholder="Ex.: Três noites de conferência para os jovens da igreja, com preleção, louvor e oficinas na tarde de sábado."
          onChange={(event) => onChangeText({ description: event.target.value || null })}
        />
      </FormField>

      <FormField
        label="Público esperado"
        error={errors.expected_audience}
        hint={
          size
            ? `Pela estimativa, é um projeto de ${size.label} — a política da igreja pede ${size.expectedLeadTimeDays} dias de antecedência.`
            : 'Número aproximado de pessoas. Ajuda a dimensionar espaço e apoio.'
        }
      >
        <Input
          type="number"
          inputMode="numeric"
          min={1}
          value={values.expected_audience ?? ''}
          placeholder="Ex.: 120"
          onChange={(event) => {
            const parsed = Number.parseInt(event.target.value, 10);
            onChangeText({
              expected_audience: Number.isFinite(parsed) && parsed > 0 ? parsed : null,
            });
          }}
        />
      </FormField>
    </FormSection>
  );
}
